/**
 * This map is used for highlighting the correct tab from navigation menu
 * when you are currently on page that is "child" of that tab.
 *
 * For key in this map is used tab's path, and for value is used string array of "children" paths.
 * For example when we are in "Create Tag" (/tags/create) or "Edit Tag" (/tags/update),
 * "Tag list" (/tags) tab should be highlighted.
 */
const NavigationRelatedTabs: Map<string, string[]> = new Map<string, string[]>([
  [
    '/qc/chats', ['/qc/chats'],
  ],
  [
    '/qc/chats/queue', ['/qc/chats/review'],
  ],
  [
    '/qc/escalations', ['/qc/escalations'],
  ],
  [
    '/qc/feedbacks', ['/qc/feedbacks'],
  ],
  [
    '/qc/dossiers', ['/qc/dossiers'],
  ],
  [
    '/qc-settings/tags', ['/qc-settings/tags/create', '/qc-settings/tags/update'],
  ],
  [
    '/qc-settings/score/types', ['/qc-settings/score/types/create', '/qc-settings/score/types/update'],
  ],
  [
    '/qc-settings/score/grades', ['/qc-settings/score/grades/create', '/qc-settings/score/grades/update'],
  ],
  [
    '/qc-settings/cron', ['/qc-settings/cron/create', '/qc-settings/cron/edit'],
  ],
  [
    '/users/', ['/users/edit'],
  ],
  [
    '/roles', ['/roles/create', '/roles/edit'],
  ],
  [
    '/departments', ['/departments/create', '/departments/edit'],
  ],
  [
    '/calendar/shifts/manage', ['/calendar/shifts/type'],
  ],
  [
    '/system-users/edit', ['/system-users/edit'],
  ],
  [
    '/qc-v2/chats/archive', ['/qc-v2/chats/archive'],
  ],
  [
    '/qc-v2/chats/queue', ['/qc-v2/chats/queue'],
  ],
  [
    '/qc-v2/feedbacks', ['/qc-v2/feedbacks'],
  ],
  [
    '/qc-v2/escalations', ['/qc-v2/escalations'],
  ],
  [
    '/qc-v2/tickets', ['/qc-v2/tickets'],
  ],
  [
    '/vhost/cdn', ['/vhost/cdn/create'],
  ],
  [
    '/vhost/origin', ['/vhost/origin/create'],
  ],
  [
    '/websites/', ['/websites/create', '/websites/quick-create'],
  ],
]);

export default NavigationRelatedTabs;
